var _rect, _path, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgHappyCircleArrowRight = function SvgHappyCircleArrowRight(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 23,
    height: 23,
    x: 0.5,
    y: 0.5,
    stroke: "url(#happyCircleArrowRight_svg__a)",
    rx: 11.5
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "url(#happyCircleArrowRight_svg__b)",
    stroke: "#fff",
    strokeWidth: 0.2,
    d: "M7.88 12.562h6.673a.098.098 0 0 1 .064.17l-3.368 2.965a.562.562 0 0 0 .74.843l4.36-3.837a.936.936 0 0 0 0-1.404l-4.358-3.836a.561.561 0 0 0-.741.843l3.368 2.963a.098.098 0 0 1-.065.171H7.88a.562.562 0 0 0 0 1.123Z"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "happyCircleArrowRight_svg__a",
    x1: 0,
    x2: 25.823,
    y1: 0,
    y2: 2.155,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D3AA53"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6B4905"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "happyCircleArrowRight_svg__b",
    x1: 16.667,
    x2: 6.624,
    y1: 16.667,
    y2: 15.828,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D3AA53"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6B4905"
  })))));
};
export default SvgHappyCircleArrowRight;